import { HTTPClientInterface, HTTPRequest } from '@shared/core/HTTPClientInterface';
import { buildURL, SystemURL } from './URLCatalog';

// Communication interface
export interface CreateCommunicationRequest {
    text: string;
    expiration: number;
}

export class CommunicationsService {
	private httpClient: HTTPClientInterface;

	constructor(httpClient: HTTPClientInterface) {
		this.httpClient = httpClient;
	}

	async getCommunication(orgId: string): Promise<any> {
		const request = new HTTPRequest();
		request.url = buildURL(SystemURL.Communications.getCommunication, { org_id: orgId });
		request.method = 'GET';
        const response = await this.httpClient.execute(request);
        return response.result;
	}

	async createCommunication(orgId: string, communicationData: CreateCommunicationRequest): Promise<any> {
		const request = new HTTPRequest();
		request.url = buildURL(SystemURL.Communications.postCreate, { org_id: orgId });
		request.method = 'POST';
		request.body = communicationData;
		return this.httpClient.execute(request);
	}

	async deleteCommunication(orgId: string): Promise<any> {
		const request = new HTTPRequest();
		request.url = buildURL(SystemURL.Communications.deleteCommunication, { org_id: orgId });
		request.method = 'DELETE';
		// No body for DELETE request
		return this.httpClient.execute(request);
	}
}
